export default __webpack_public_path__ + "static/media/american-express.a7a146b0.png";